import { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Prompt from "../../components/UI/Popup/Prompt";
import Button from '../../components/UI/Button/Button';

export function LeavePageConfirmation(props) {
  const history = useHistory();
  const [showPrompt, setShowPrompt] = useState(false)
  const [path, setPath] = useState('')
  const { when, save } = props;
  const buttons = [
    <Button
      label="back"
      buttonClick={() => setShowPrompt(false)}
      content="Back"
      variant="btn_secondary"
      key="backButton"
      styles="neutralGrey wrapContent"
    />,
    <Button
      label="Save Changes"
      buttonClick={() => {
        setShowPrompt(false)
        save()
        history.block(() => {})
        history.push(path)
      }}
      content="Save Changes"
      variant="btn_secondary"
      key="saveButton"
      styles="neutralGrey wrapContent"
    />,
    <Button
      label="Discard changes"
      buttonClick={() => {
        setShowPrompt(false)
        history.block(() => { })
        history.push(path)
      }}
      content="Discard changes"
      variant="btn_secondary"
      key="discardButton"
      styles="neutralGrey wrapContent"
    />
  ]

  useEffect(() => {
    const unblock = history.block((transaction) => {
      // unblock the redirection when users press logout
      if(window.isUserLogginOut){
        return true;
      }
      if (when) {
        setShowPrompt(true)
        setPath(transaction.pathname)
        return false
      } else {
        unblock()
      }
    })

    return (() => unblock())
  }, [history, when])

  return (
    showPrompt ? <Prompt
      titleText="Please note"
      subtitleText="Would you like to save your availability entries before leaving?"
      buttons={buttons}
      isVisible={showPrompt}
      onClose={() => setShowPrompt(false)}

    /> : <></>
  )

}